export interface IRetryState {
  savedPayloads: Map<string, any>;
}

export const initialRetryState: IRetryState = {
  savedPayloads: new Map<string, any>(),
};
